module.exports = __webpack_public_path__ + "img/fax.9f26ca4a.svg";